export const salonQueryKeys = {
  salonInfo: (salonId: string) => ["salonInfo", salonId] as const,
  salonOverview: (salonId: string) => ["salonOverview", salonId] as const,
} as const;
